<script setup lang="ts">
import SetupWizard from '@/components/setupWizard.vue';
</script>

<template>
	<v-app>
		<setup-wizard />
	</v-app>
</template>
